import { render, staticRenderFns } from "./PaymentTab.vue?vue&type=template&id=31db41aa&scoped=true"
import script from "./PaymentTab.vue?vue&type=script&lang=js"
export * from "./PaymentTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentTab.vue?vue&type=style&index=0&id=31db41aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db41aa",
  null
  
)

export default component.exports